// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"f5286a85","648":"1ee2f839","720":"f216bf55","744":"b94e5274","792":"a5a5f700"}[chunkId] + ".chunk.js";
};